import { render } from "./Platform.vue?vue&type=template&id=4afe6aa6&scoped=true"
import script from "./Platform.vue?vue&type=script&lang=js"
export * from "./Platform.vue?vue&type=script&lang=js"

import "./Platform.vue?vue&type=style&index=0&id=4afe6aa6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afe6aa6"]])

export default __exports__